import {
  OrderSelectionOptionItem,
  OrderStatusCode,
  ROLE,
} from '../../interface/interface';

export const handleInvalidOrderStatus = (
  groups: unknown,
  allOrderStatus: OrderSelectionOptionItem[],
  commonAdminStatuses: OrderStatusCode[],
) => {
  if ((groups as string[])[0] === ROLE.Admin) {
    return allOrderStatus.filter((e) => commonAdminStatuses.includes(e?.id));
  }
  return [];
};
